module.exports = __webpack_public_path__ + "resources/icon-marrow.2ba598a07aa3c515.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-title/images/icon-marrow.png
// module id = 531
// module chunks = 0 1 2 3